function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":_vm.smCols,"md":_vm.mdCols}},_vm._l((_vm.content),function(ref){
var _uid = ref._uid;
var component = ref.component;
var rest = objectWithoutProperties( ref, ["_uid", "component"] );
var props = rest;
return _c(component,_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(props),expression:"props"}],key:_uid,tag:"component"},'component',props,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }